// Helpers for the Sensor Samples Report (WEB-1092).
//
// "Acoustic" sensors are the Aquarius noise sensors (G4 / Edge / Ultra), i.e.
// anything that is NOT a pressure sensor. Generation is derived from
// DeviceGenerationValue: 0 = G4, 1 = G5 (Edge/Ultra, distinguished by isMini —
// not needed here since both are acoustic). The raw sensor objects live at
// state.leaksList.leaksByProject[projectId].sensors.sensors and are the same
// objects the map polygon selection yields.

export const isAcousticSensor = (sensor) =>
  !!sensor &&
  !sensor.isPressureSensor &&
  (sensor.DeviceGenerationValue === 0 || sensor.DeviceGenerationValue === 1);

// Build react-select options ({ value, label }) for the acoustic sensors,
// sorted by id.
export const acousticSensorOptions = (sensors) =>
  (sensors || [])
    .filter(isAcousticSensor)
    .map((sensor) => ({
      value: String(sensor.id),
      label: sensor.DeviceID ? `${sensor.id} — ${sensor.DeviceID}` : `${sensor.id}`,
    }))
    .sort((a, b) => Number(a.value) - Number(b.value));

// Acoustic sensor ids from a list of sensor objects (e.g. a polygon selection).
export const acousticSensorIds = (sensors) =>
  (sensors || []).filter(isAcousticSensor).map((sensor) => String(sensor.id));
